// extracted by mini-css-extract-plugin
export default {"itemThumbsRoot":"ItemThumbs_itemThumbsRoot__U4OxH"};